import dynamic from "next/dynamic";

export const SocialLink = dynamic(() => import("./component"));
